import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { AWS_IMAGE_URL, WEB_LINK } from '../../constants/constants';
import { UserService } from '../../service/user.service';
import { ADArray, BevviAD } from '../../interfaces/bevviad';
import { CustomjsService } from '../../service/customjs.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'bevvi-fullwidthad',
  templateUrl: './fullwidthad.component.html',
  styleUrls: ['./fullwidthad.component.scss']
})
export class FullwidthadComponent implements OnInit {

  // BEVVI Banner Feature
  public canShow: boolean = false;
  // public slider: TinySliderInstance & {lazyloadSelector: string};
  public slider: any;
  public numOfBanner: number = 0;
  public adArray: Array<ADArray>
  public storeIndexTrack: Array<number> = [];
  public imageUrl = AWS_IMAGE_URL;
  public webLink = WEB_LINK + '';
  private gaSet: boolean = false;
  private gaClickPromo: any;
  
  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private customJS: CustomjsService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private router: Router
  ) { }

  ngOnInit() {

    this.apiService.getData(this.apiService.constants.GET_BEVVI_AD, {receipt: false}, true)
    .subscribe(
      (adResponse: BevviAD) => {
        // console.log(adResponse);
        this.customJS.loadSlider();
        if (adResponse.showAds) {
          this.canShow = true;
          this.adArray = adResponse.productAdsArray;
          this.userService.adsActive(true);
          
        } else {
          this.userService.adsActive(false);
          this.canShow = false;
        }
      }
    )
    
  }

  goToPage(fileName, companyName) {
    if (this.gaSet) {
      this._renderer2.removeChild(this._document.body, this.gaClickPromo);
    }
    console.log('Hi')
    this.gaSet = true;
    let product;
    if (fileName.includes('Scapegrace')) {
      product = 'Scapegrace';
    } else if (fileName.includes('Sobeiski')) {
      product = 'Sobeiski';
    } else if (fileName.includes('Marie')) {
      product = 'Marie'
    }
    this.gaClickPromo = this._renderer2.createElement('script');
    this.gaClickPromo.text = 'text/javascript';
    this.gaClickPromo.id = 'ga-track-pageviews';
    this.gaClickPromo.async = true;
    this.gaClickPromo.defer = true;
    this.gaClickPromo.text = `gtag('event', 'select_content', {
      "promotions": [
        {
          "id": ${companyName},
          "name": ${product}
        }
      ]
    });`;

    this._renderer2.appendChild(this._document.body, this.gaClickPromo);
    console.log('Hello')
    this.router.navigate(['/company/'+companyName]);
  }

}
